import axios from 'axios'
import qs from 'qs'
import fn from '../../utils/functions'
import dayjs from 'dayjs';

// Normaliza fechas en profundidad para evitar que qs.stringify destruya objetos Dayjs
export function convertDates(obj) {
  if (obj == null) return obj;

  // Detecta Day.js correctamente
  if (dayjs.isDayjs(obj)) {
    return obj.toISOString();
  }

  // Detecta Date nativo
  if (obj instanceof Date) {
    return obj.toISOString();
  }

  // Arrays → recorrer
  if (Array.isArray(obj)) {
    return obj.map(item => convertDates(item));
  }

  // Objetos → recorrer recursivamente
  if (typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      newObj[key] = convertDates(obj[key]);
    }
    return newObj;
  }

  
  return obj;
}

function initSession () {
  const session = {
    // Perfiles
    profiles: {
      tableData: [],
      totalProfiles: 0
    },
    queryProfiles: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      name: null,
      description: null,
      creationDateTimeFrom: null,
      creationDateTimeTo: null,
      projectId: null
    },
    listSelectedFiltersProfiles: [],

    // Permisos
    authoritiesProfiles: {
      tableData: [],
      totalAuthorities: 0
    },

    // Datos Select Filtros Perfiles
    optionsFilterNameProfiles: [],
    optionsFilterDescriptionProfiles: [],
    optionsFilterProjectProfiles: []
  }
  return session
}
function initLocal () {
  const local = {
    // Columnas Tabla Perfiles
    isShowNameProfiles: true,
    isShowDescriptionProfiles: true,
    isShowDateCreationProfiles: true, // F.Registro
    isShowProjectProfiles: true
  }
  return local
}
function setByUserLocalProfile () {
  const local = {
    // Columnas Tabla Perfiles
    isShowNameProfiles: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).profiles.isShowNameProfiles,
    isShowDescriptionProfiles: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).profiles.isShowDescriptionProfiles,
    isShowDateCreationProfiles: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).profiles.isShowDateCreationProfiles, // F.Registro
    isShowProjectProfiles: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).profiles.isShowProjectProfiles
  }
  return local
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {
    // Columnas Tabla Perfiles
    isShowNameProfiles: true,
    isShowDescriptionProfiles: true,
    isShowDateCreationProfiles: true, // F.Registro
    isShowProjectProfiles: true
  },
  session: initSession()
}

// getters
const getters = {
  // Permisos
  authoritiesProfiles: state => {
    return state.session.authoritiesProfiles
  },

  // Datos Tabla Perfiles
  profiles: state => {
    return state.session.profiles
  },
  queryProfiles: state => {
    return state.session.queryProfiles
  },
  listSelectedFiltersProfiles: state => {
    return state.session.listSelectedFiltersProfiles
  },

  // Datos Select Filtros Perfiles
  optionsFilterNameProfiles: state => {
    return state.session.optionsFilterNameProfiles
  },
  optionsFilterDescriptionProfiles: state => {
    return state.session.optionsFilterDescriptionProfiles
  },
  optionsFilterProjectProfiles: state => {
    return state.session.optionsFilterProjectProfiles
  },

  // Columnas Tabla Perfiles
  isShowNameProfiles: state => {
    return state.local.isShowNameProfiles
  },
  isShowDescriptionProfiles: state => {
    return state.local.isShowDescriptionProfiles
  },
  isShowDateCreationProfiles: state => {
    return state.local.isShowDateCreationProfiles
  },
  isShowProjectProfiles: state => {
    return state.local.isShowProjectProfiles
  }
}

// actions
const actions = {
  // Crear key Usuario
  setUserNameProfile ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalProfile()
    }
  },
  async isNewVersionProfilesLocalState ({ state }, localStorage) {
    const isnew = fn.isNewVersion(state, localStorage.profiles)
    return isnew
  },

  /* PROFILES */
  /**
  * Servicio para traer las Perfiles .
  * Se utiliza también para ordenar la tabla, la paginación,
  * el tamaño de la tabla y los filtros.
  */
  async getProfiles ({ commit, rootState }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/role',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })

      console.log('RESPONSE getProfiles:: ', response)

      commit('PROFILES_STATE', {
        tableData: response.data.content,
        totalProfiles: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Modifica un perfil */
  async modifyProfile ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/role/' + request.roleId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          roleId: request.roleId,
          idProject: request.idProject,
          name: request.name,
          description: request.description,
          erasable: request.erasable,
          authorityIds: request.authorityList
        }
      })

      console.log('RESPONSE modifyProfile:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para eliminar un perfil
   * @param {*} roleId
   */
  async deleteProfile ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/role/' + params.roleId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

   // Servicio para traer detalle de un perfil
   async getProfileDetail ({ commit, rootState }, roleId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/role/' + roleId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  }, 

  // Permisos
  authoritiesProfilesState: ({ commit }, payload) => {
    commit('PROFILES_AUTHORITIES_STATE', payload)
  },
  // Datos Tabla Perfiles
  profilesState: ({ commit }, payload) => {
    commit('PROFILES_STATE', payload)
  },
  queryProfilesState: ({ commit }, payload) => {
    commit('QUERY_PROFILES_STATE', payload)
  },
  listSelectedFiltersProfilesState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_PROFILES_STATE', payload)
  },

  // Datos Select Filtros Perfiles
  optionsFilterNameProfilesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_NAME_PROFILES', payload)
  },
  optionsFilterDescriptionProfilesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DESCIPTION_PROFILES', payload)
  },
  optionsFilterProjectProfilesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PROJECT_PROFILES', payload)
  },
  // Columnas Tabla Perfiles
  isShowNameProfilesAction: ({ commit }, payload) => {
    commit('IS_SHOW_NAME_PROFILES', payload)
  },
  isShowDescriptionProfilesAction: ({ commit }, payload) => {
    commit('IS_SHOW_DESCIPTION_PROFILES', payload)
  },
  isShowDateCreationProfilesAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_CREATION_PROFILES', payload)
  },
  isShowProjectProfilesAction: ({ commit }, payload) => {
    commit('IS_SHOW_PROJECT_PROFILES', payload)
  }
}

// mutations
const mutations = {
  resetSessionProfiles (state) {
    state.session = initSession()
    state.local = initLocal()
  },

  // Permisos
  'PROFILES_AUTHORITIES_STATE' (state, payload) {
    state.session.authoritiesProfiles = payload
  },

  // Perfiles
  'PROFILES_STATE' (state, payload) {
    state.session.profiles = payload
  },
  'QUERY_PROFILES_STATE' (state, payload) {
    state.session.queryProfiles = payload
  },
  'LIST_SELECTED_FILTERS_PROFILES_STATE' (state, payload) {
    state.session.listSelectedFiltersProfiles = payload
  },

  // Datos Select Filtros Perfiles
  'OPTIONS_FILTER_NAME_PROFILES' (state, payload) {
    state.session.optionsFilterNameProfiles = payload
  },
  'OPTIONS_FILTER_DESCIPTION_PROFILES' (state, payload) {
    state.session.optionsFilterDescriptionProfiles = payload
  },
  'OPTIONS_FILTER_PROJECT_PROFILES' (state, payload) {
    state.session.optionsFilterProjectProfiles = payload
  },

  // Columnas Tabla  Perfiles
  'IS_SHOW_NAME_PROFILES' (state, payload) {
    state.local.isShowNameProfiles = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.profiles.isShowNameProfiles = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DESCIPTION_PROFILES' (state, payload) {
    state.local.isShowDescriptionProfiles = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.profiles.isShowDescriptionProfiles = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_CREATION_PROFILES' (state, payload) {
    state.local.isShowDateCreationProfiles = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.profiles.isShowDateCreationProfiles = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PROJECT_PROFILES' (state, payload) {
    state.local.isShowProjectProfiles = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.profiles.isShowProjectProfiles = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
